import React, { useEffect, useState } from 'react'
import { arrayOf } from '../../../../utils/StoreUtils'
import i18n from 'simple-react-i18n'
import Select from '../../../../components/forms/Select'
import Row from '../../../../components/react/Row'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import PropTypes from 'prop-types'
import Job from '../../../dto/DtoJob'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import Button from '../../../../components/forms/Button'
import CityAction from '../../../../referencial/components/city/actions/CityAction'
import Checkbox from '../../../../components/forms/Checkbox'
import SelectionTableModal from '../../../../components/modal/SelectionTableModal'
import { normalizeString } from '../../../../utils/StringUtil'
import { Grid2 } from '@mui/material'
import { SimpleFilterField } from '../../../../components/datatable/SimpleSelectionTable'
import IntegrationModeDialog from '../IntegrationModeDialog'


const MeteoFranceRadarPanel = ({
    isEditMode,
    onChangeFilters,
    filters = {},
}) => {
    const [cityPopupOpen, setCityPopupOpen] = useState(false)
    const dispatch = useDispatch()

    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    useEffect(() => {
        if (!cities.length) {
            dispatch(CityAction.fetchCities())
        }
        if (!Object.keys(filters).length) {
            onChangeFilters({
                importMode: 'DATA_ADD_LAST_DATA',
                cities: [],
                rain: true,
                etp: true,
                radiation: true,
                temperature: true,
            })
        }
    }, [])

    const disabled = !isEditMode

    return (
        <div>
            <Grid2 container rowSpacing={1} spacing={1} >
                <Grid2 size={4}>
                    <fieldset className='width-100'>
                        <legend>&nbsp;{ i18n.datas }&nbsp;</legend>
                        <Grid2 container rowSpacing={1} spacing={1} alignItems='center' justifyContent='center'>
                            <Grid2 size={8} >
                                <Select options={ getIntegrationModes() } obligatory={ true }
                                    label={ i18n.dataIntegration } value={ filters.importMode }
                                    labelSpan={ <IntegrationModeDialog /> }
                                    onChange={ v => onChangeFilters({ importMode: v }) }
                                    disabled={ disabled }
                                />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label={i18n.rain} checked={filters.rain} onChange={c => onChangeFilters({ rain: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label={i18n.etp} checked={filters.etp} onChange={c => onChangeFilters({ etp: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label={i18n.temperature} checked={filters.temperature} onChange={c => onChangeFilters({ temperature: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label={i18n.radiation} checked={filters.radiation} onChange={c => onChangeFilters({ radiation: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label='ETR' checked={filters.etr} onChange={c => onChangeFilters({ etr: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label='Humidité' checked={filters.humidity} onChange={c => onChangeFilters({ humidity: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label='Humidité du sol (SWI)' checked={filters.soilHumidity} onChange={c => onChangeFilters({ soilHumidity: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label='Vent' checked={filters.wind} onChange={c => onChangeFilters({ wind: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label='Drainage' checked={filters.drain} onChange={c => onChangeFilters({ drain: c })} disabled={ disabled } />
                            </Grid2>
                            <Grid2 size={8}>
                                <Checkbox label='Ruissellement' checked={filters.runoff} onChange={c => onChangeFilters({ runoff: c })} disabled={ disabled } />
                            </Grid2>
                        </Grid2>
                    </fieldset>
                </Grid2>
                <Grid2 size={4}>
                    <fieldset className='width-100'>
                        <legend>&nbsp;{ i18n.previData }&nbsp;</legend>
                        <Grid2 container rowSpacing={1} alignItems='center' justifyContent='center'>
                            <Grid2 size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions AROME (3 jours)'
                                    checked={filters.addAROMEdata}
                                    onChange={c => onChangeFilters({ addAROMEdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions ARPEGE (5 jours)'
                                    checked={filters.addARPEGEdata}
                                    onChange={c => onChangeFilters({ addARPEGEdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions ECMWF (15 jours)'
                                    checked={filters.addECMWFdata}
                                    onChange={c => onChangeFilters({ addECMWFdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <Checkbox
                                    label='Importer les seeds ECMWF (utilisé pour la modélisation)'
                                    checked={filters.addECMWFSeedsdata}
                                    onChange={c => onChangeFilters({ addECMWFSeedsdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid2>
                        </Grid2>
                    </fieldset>
                </Grid2>
                <Grid2 size={4}>
                    <fieldset className='width-100'>
                        <legend>&nbsp;{ i18n.cities }&nbsp;</legend>
                        <Row>
                            <Button col={ 12 } title={ `${(filters.cities || []).length} ${i18n.cities}` } onClick={ () => setCityPopupOpen(true) } disabled={ disabled }/>
                        </Row>
                    </fieldset>
                </Grid2>
            </Grid2>
            <SelectionTableModal
                isOpen={cityPopupOpen}
                onClose={() => setCityPopupOpen(false)}
                onValidate={list => {
                    onChangeFilters({ cities: list })
                    setCityPopupOpen(false)
                }}
                title={i18n.cities}

                listData={cities}
                defaultSelectionList={filters.cities ?? []}

                listHeaders={['code', 'name']}
                listTitle={i18n.cities}
                selectionListTitle={i18n.selectedElements}
                maxHeightTable={'48vh'}


                filterField={SimpleFilterField}
                filterFunction={(list, { searchValue }) => {
                    const searchValueFormat = normalizeString(searchValue)
                    return searchValue ? list.filter(p => normalizeString([p.code, p.name].join('   ')).includes(searchValueFormat)) : list
                }}
            />
        </div>
    )
}

MeteoFranceRadarPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    cities: arrayOf(CityDto),
    filters: PropTypes.shape({}),
}

export default MeteoFranceRadarPanel